import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
    // baseUrl: process.env.REACT_APP_API_URL,
    // baseUrl: "http://localhost:8000/",
    baseUrl: "https://api-dev.ambitmis.co/",
    credentials: "include",
    prepareHeaders: (headers) => {
        // No need to manually add headers for session-based authentication
        return headers;
    },
});

const baseQueryWithInterceptor = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    // If the API call was successful, update the last activity
    if (result.data) {
        // Get the updateActivity function from localStorage (we'll set this when app initializes)
        const updateActivity = window._updateActivity;
        if (typeof updateActivity === "function") {
            updateActivity();
        }
    }
    if (
        result.error &&
        (result.error.status === 403 || result.error.status === 401)
    ) {
        // api.dispatch(logout());
        window.location.href =
            "https://ambit.ssoone.com?appnamesso1=ambit_mis_analytics";
    }
    return result;
};

export const api = createApi({
    baseQuery: baseQueryWithInterceptor,
    endpoints: () => ({}),
    tagTypes: [
        "User",
        "Sector",
        "Category",
        "SubCategory",
        "Tier",
        "Client",
        "Trader",
        "RatingSpread",
        "SectorAssignment",
        "AnalystAssignment",
        "AnalystList",
        "Todo",
    ],
});
